import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8d6b9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "recommended-action-card",
  role: "group",
  "aria-label": "Recommended Action"
}
const _hoisted_2 = { class: "action-messages" }

import Skeleton from 'primevue/skeleton'

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionCardLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Skeleton), {
        height: "1.3rem",
        width: "90%"
      }),
      _createVNode(_unref(Skeleton), {
        height: "1.3rem",
        width: "90%"
      })
    ]),
    _createVNode(_unref(Skeleton), {
      height: "38px",
      width: "70px"
    })
  ]))
}
}

})